import React from 'react';
import { Route, IndexRoute } from 'react-router';
import SummaryMainContainer from './containers/SummaryMainContainer';

export default (
        <Route path="/date" component={SummaryMainContainer}  name="Summary">
    </Route>
);


// WEBPACK FOOTER //
// ./src/routes.js